document.addEventListener("DOMContentLoaded", () => {
  const productSwiper = document.querySelectorAll('.product-swiper');
  const productSwiperArray = new Array();

  if ( productSwiper.length == 0 ) return;

  for ( var i=0; i < productSwiper.length; i++ ) {
    productSwiperArray[i] = new Swiper('#'+productSwiper[i].id, {
      loop: false,
      lazy: true,
      slidesPerView: 2,
      spaceBetween: 8,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      mousewheel: {
        releaseOnEdges: true,
        forceToAxis: true,
      },
      navigation: {
        nextEl: ".product-swiper .swiper-button-next",
        prevEl: ".product-swiper .swiper-button-prev",
      },
      pagination: {
        el: '.swiper-pagination',
        type: "bullets",
        clickable: true, 
        dynamicBullets: false,
      },
      breakpoints: {
        1025: {
          slidesPerView: 3,
          spaceBetween: 8,
        },
        1600: {
          slidesPerView: 5,
          spaceBetween: 8,
        },
      },
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

    productSwiperArray[i].on('slideChange', function(swiper) {
      swiper.pagination.render();
      swiper.pagination.update();
    });
  }
});